import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FeatureSliderComponent } from '@shared/feature-slider/feature-slider.component';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { featuresContent } from '@shared/features-content/features-content';
import { FeaturesItemComponent } from '@shared/features-item/features-item.component';
import { ArrowComponent } from '@shared/arrow/arrow.component';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { NgOptimizedImage } from '@angular/common';
import { CarouselAnimationComponent } from '@shared/carousel-animation/carousel-animation.component';
import { ScrollComponent } from '@shared/scroll/scroll.component';
import { FeaturesItem } from '@content/features/features-type';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-home-features',
    imports: [
        FeatureSliderComponent,
        ContentWrapperComponent,
        FeaturesItemComponent,
        ArrowComponent,
        AssetPipe,
        NgOptimizedImage,
        CarouselAnimationComponent,
        RouterLink,
    ],
    templateUrl: './home-features.component.html',
    styleUrl: './home-features.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeFeaturesComponent extends ScrollComponent {
    public readonly featuresContent: FeaturesItem[] = featuresContent;

    public onSelectFeature(id: number): void {
        this.changeActiveId(id);
    }
}
